import type * as React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { size?: number | string };

export const Close = ({ size, ...props }: IconProps) => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 16 17"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M9.41492 8.63982L12.7085 5.34628C12.8956 5.15879 13.0007 4.90472 13.0007 4.63982C13.0007 4.37492 12.8956 4.12084 12.7085 3.93336C12.6156 3.8404 12.5053 3.76666 12.3839 3.71635C12.2625 3.66603 12.1324 3.64014 12.001 3.64014C11.8696 3.64014 11.7395 3.66603 11.6181 3.71635C11.4967 3.76666 11.3865 3.8404 11.2936 3.93336L8.00005 7.23473L4.70846 3.94314C4.61559 3.85019 4.50531 3.77644 4.38393 3.72613C4.26254 3.67582 4.13243 3.64992 4.00103 3.64992C3.86963 3.64992 3.73951 3.67582 3.61812 3.72613C3.49673 3.77644 3.38645 3.85019 3.29358 3.94314C3.10644 4.13063 3.00134 4.3847 3.00134 4.6496C3.00134 4.9145 3.10644 5.16858 3.29358 5.35606L6.58713 8.6496L3.29358 11.9314C3.10644 12.1189 3.00134 12.373 3.00134 12.6379C3.00134 12.9028 3.10644 13.1568 3.29358 13.3443C3.38625 13.4373 3.49635 13.5111 3.61757 13.5615C3.7388 13.6118 3.86878 13.6378 4.00005 13.6379C4.13165 13.6381 4.26199 13.6122 4.38357 13.5618C4.50515 13.5115 4.61557 13.4375 4.70846 13.3443L8.00005 10.0508L11.2936 13.3443C11.3862 13.4373 11.4963 13.5111 11.6176 13.5615C11.7388 13.6118 11.8688 13.6378 12.0001 13.6379C12.1317 13.6381 12.262 13.6122 12.3836 13.5618C12.5051 13.5115 12.6156 13.4375 12.7085 13.3443C12.8956 13.1568 13.0007 12.9028 13.0007 12.6379C13.0007 12.373 12.8956 12.1189 12.7085 11.9314L9.41492 8.63982Z"
			fill="#141938"
		/>
	</svg>
);
